import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
import store from './store/store'
import './router/http' // 引入axios
import './other/ivewImport'  // ivew 模块引入  
import './other/plugin' // 所有引入的第三方插件
import axios from 'axios'
import router from './router/router'
import dateTool from 'date-and-time'
axios.prototype.$https = axios
import './assets/scss/my-theme/my-theme.less'
import './assets/scss/index.scss'
import './assets/iconfont/iconfont.css'
import VueCookies from 'vue-cookies'


// import i18n from "./i18n";
// import VueI18n from 'vue-i18n';
// import en from 'view-design/dist/locale/en-US';
// import zh from 'view-design/dist/locale/zh-CN';
import echarts from 'echarts'

import regular from "./utils/time";
Vue.prototype.regular = regular;

import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'vant/lib/index.less';
// import "@scss/element-variables.scss";

import { vantPlugins } from './utils/vant.js'


Vue.use(vantPlugins)

Vue.use(Element)


Vue.prototype.$echarts = echarts 
Vue.config.productionTip = false
Vue.use(router)
Vue.use(VueCookies)
 

//全局过滤器
Vue.filter('dateFormat', function (value) {
  return dateTool.format(new Date(value), "YYYY-MM-DD HH:mm:ss")
})

Vue.filter('character', (val) => {
  return val.replaceAll(',', '/');
})

new Vue({
  router,
  store,
//   i18n,
  render: h => h(App)
}).$mount('#app')
